import { useQuery } from "@tanstack/react-query";
import $api from "@/frontend/shared/api/axios";

export const useAuthenticated = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["session-verify"],
    queryFn: async (): Promise<boolean> => {
      try {
        const response = await $api.post("/session/verify");
        const isLoggedIn = response?.data?.data?.loggedIn;
        return isLoggedIn;
      } catch {
        return false;
      }
    }
  });

  return { data, isLoading, refetch };
};
